module.exports = __webpack_public_path__ + "media/images/case_image02-9e023832.svg";